import { ContentItem } from '@kentico/kontent-delivery';
import { ColumnModel } from './column-model';
import { IGridProps } from '../components/grid/grid';
import { IColumnProps } from '../components/grid/column/column';
import { SpaceBetweenColumnsType } from '../typings';
import get from 'lodash/get';

export class GridModel extends ContentItem {
  get columns(): IColumnProps[] {
    const getColumns = get(this._config, 'elements.grid.value', null);

    const transformColumns = getColumns
      ? getColumns.map((column: IColumn) => ColumnModel.create(column))
      : null;
    return transformColumns;
  }

  get marginBetweenItems(): SpaceBetweenColumnsType {
    return get(
      this._config,
      'elements.margin_between_items__choose.value[0].codename',
      ''
    );
  }

  get autoWidth(): boolean {
    return (
      get(this._config, 'elements.auto_width.value[0].codename') === 'true'
    );
  }

  get wrappColumns(): string {
    return get(this._config, 'elements.wrapp_columns.value[0].codename', '');
  }

  get wrappColumnsReverse(): boolean {
    return (
      get(
        this._config,
        'elements.wrapp_columns_reverse.value[0].codename',
        ''
      ) === 'true'
    );
  }

  public static create(data: IGrid): IGridProps {
    const {
      columns,
      marginBetweenItems,
      wrappColumns,
      wrappColumnsReverse,
      autoWidth,
      id
    } = new GridModel(data);
    return {
      columns,
      marginBetweenItems,
      wrappColumns,
      wrappColumnsReverse,
      autoWidth,
      id
    };
  }
}
